module.exports = __webpack_public_path__ + "static/media/recommendation5.11fcdf32.jpeg";